import { apiClient } from '../utils/api-client';

export interface NotificationPreference {
  notification_type: string;
  push_enabled: boolean;
  email_enabled: boolean;
}

interface NotificationPreferencesResponse {
  data: NotificationPreference[];
}

class NotificationPreferencesService {
  async getPreferences(): Promise<NotificationPreference[]> {
    const response = await apiClient.get('/api/notification_preferences', { requireAuth: true });
    if (!response.ok) throw new Error('Failed to fetch notification preferences');
    const json: NotificationPreferencesResponse = await response.json();
    return json.data;
  }

  async updatePreferences(preferences: NotificationPreference[]): Promise<void> {
    const response = await apiClient.patch(
      '/api/notification_preferences',
      { data: { preferences } },
      { requireAuth: true }
    );
    if (!response.ok) throw new Error('Failed to update notification preferences');
  }
}

export const notificationPreferencesService = new NotificationPreferencesService();
